module.exports = __webpack_public_path__ + "static/media/6305.743785b1.svg";